export const DOCUMENT_TYPES = {
  CNPJ: "CNPJ",
  CPF: "CPF",
  CUIT: "CUIT",
};
